<template>
  <v-card
    class="bodyText"
    style="background-color: var(--color-bg) !important"
  >
    <v-card-title
      class="bodyBold"
      style="color: var(--color-text)"
    >
      {{ cardData.title }}
    </v-card-title>
    <v-card-actions>
      <v-container class="containerView">
        <v-row
          style="height: 60%"
          class="rowView"
        >
          <span
            v-if="
              cardData.Value == null ||
                cardData.Value == 'null' ||
                cardData.Value == -1000
            "
            :class="valClass + ' bottomAlign bodyText'"
            style="color: var(--color-text) !important"
          >
            -
          </span>
          <span
            v-else-if="cardData.format == ''"
            :class="valClass + ' bottomAlign bodyText'"
            style="color: var(--color-text) !important"
          >
            {{ cardData.Value }}
          </span>
          <span
            v-else
            :class="valClass + ' bottomAlign bodyText'"
            style="color: var(--color-text) !important"
          >
            {{ cardData.Value.toFixed(cardData.format) }}
          </span>
        </v-row>
        <v-row
          style="height: 40%"
          class="rowView"
        >
          <span
            v-if="cardData.Label != ''"
            class="body1 topAlign"
            style="padding-left: 10px; color: var(--color-text) !important"
          >
            {{ cardData.Label }}
          </span>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CardSingleValue",
  components: {},
  props: {
    cardData: Object,
    valClass: String,
  },
  data: function () {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
